module.exports = __webpack_public_path__ + "img/logo_text_right.ab772e67.png";